











import Vue from 'vue';
import NotificationsLayout from '@/components/Layouts/Notifications.vue';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { fr } from 'date-fns/esm/locale';
import { mapGetters } from 'vuex';


export default Vue.extend({
  name: 'challenge-join',
  components: {
    NotificationsLayout,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('games', ['games']),
    game(): any {
      if (!this.games) { return null; }
      const gameId = this.notification.payload.challenge.game_id;
      return this.games.find((g) => g.id == gameId);
    },
    opponentName(): string {
      return this.notification.payload.opponent;
    },
    bet(): number {
      return this.notification.payload.challenge.bet;
    },
    mode(): any {
      if (!this.game) { return null; }
      const modeId = this.notification.payload.challenge.mode_id;
      return this.game.modes.find((m) => m.id == modeId);
    },
    modeLabel(): any {
      if (!this.mode) { return null; }
      return this.mode.label;
    },
    gameSlug(): any {
      if (!this.game) { return null; }
      return this.game.slug;
    },
    challenge(): any {
      return this.notification.payload.challenge;
    },
    delay(): any {
      return formatDistanceToNow(new Date(this.notification.created_at), { locale: fr });
    },
  },
});
